import styled from "styled-components";
import { ReactComponent as Plus } from "../../images/plus.svg";

export const Button = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 52px;
  height: 52px;
  margin: -26px auto 0;
  border: none;
  border-radius: 50%;
  background: #ff6b08;
`;
export const Icon = styled(Plus)``;
